import React from "react";
import { Button, ButtonProps } from "reactstrap";
import ActionGuard from "./ActionGuard";

interface CommonButtonProps extends ButtonProps {
  module?: string;
  action?: string;
}

const CommonButton: React.FC<CommonButtonProps> = ({ 
  module, 
  action, 
  children, 
  ...rest 
}) => {
  
  if (!module) {
    return <Button {...rest}>{children}</Button>;
  }

  return (
    <ActionGuard module={module} action={action}>
      <Button {...rest}>{children}</Button>
    </ActionGuard>
  );
};

export default CommonButton;
